/*jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true*/
/* globals TweenMax:true, TweenLite:true*/
/*
*	jQuery Estee Lauder Carousel Plugin
*              ___
*        _____|| ||_____     *BEEP BOOP*
*        | o  |___|  o |
*        |   [(===)]   |
*        |_____| |_____|
*   ___  ____//\_/\\____  ___
*  |   | |_|___\_/___|_| |   |
* [|   |]| |===      | |[|   |]
*  |___| |_|o_______o|_| |___|
*   \ |    \|_______|/    | /
*  _|_|_    [__|_|__]    _|_|_
*  |___|      |___|      |___|  
*  |   |       | |       |   |
*             [| |]
*/

/**
*	A jQuery plugin to create, populate, and control a horizontal carousel. This plugin also assumes that the DOM has already been properly set up and stylized; the only changes are the addition of dynamically created slides (if needed).
*	@version 0.0.7
*	@author Aric Ng
* 	
* 	0.0.6
*   - Removed event bindings from options (better handled outside of this plugin)
*   - Added update and carouselUpdate function to handle added/removed/new slides
*   - Removed any vanilla class markers
*   - Added $.fn.each functionality in plugin functions so that all elements in the selector are affected
*
*	0.0.7
*	- Added previous carousel functionality for backwards compatibility
*/



/**
 * The jQuery plugin namespace.
 * @external "jQuery.fn"
 * @see {@link http://learn.jquery.com/plugins/|jQuery Plugins}
 */

(function($){
	"use strict";
	
	/**
	@global
	*/
	var console_flag = window.console ? true : false;

	/**
	* Carousel
	*
	* builds a carousel given a target, slide template, data, and options
	* @class Carousel
	* @constructor
	* @param {jQuery} $target - the target jQuery object which will be a carousel
	* @param {object} options - An array of objects to set different options for the carousel object
	*	@param {boolean} [options.debug=false] - sets the carousel to log to console
	*	@param {string} [options.increment=0] - sets the increment to position slides ex: 9px, 9%, 9.9px, 9.9%.
	*	@param {string} [options.offset=0] - sets the from the left edge of the carousel ex. 9px, 9% 9.9px, 9.9%. Must match units used in increment, i.e. px with px; if increment is set in the options.
	*	@param {float} [options.duration=0] - sets the animation speed if GSAP
	*	@param {boolean} [options.useGSAP=true] - Wether to use GSAP for animations or not.
	*	@param {jQuery} [options.$template=false] - the target jQuery object which should be used as a template for slides. If this value isn't set, it will be assumed that the carousel's children are the slides.
	*	@param {object} [options.data=[]] - An array of objects representing data... [TEMP]
	* 	@param {int} [options.minimum=0] - Minimum amount of slides for animation to happen
	* 	@param {jQuery} [options.$slides] - Slides to use for carousel
	* 	@param {string} [options.ignoreTargets] - Elements to ignore, they will not be processed or positioned. Recommended to hide these elements with display: none
	* 	@param {string} [options.activeClass='active'] - Active class to mark elements with, defaults to 'active', has no bearing on carousel functionality, but marks the 'current' slide
	* @param $ {jQuery} - Passed in to ensure jQuery is available for the carousel
	* @returns {object} - Returns a Carousel object. Null if the carousel fails to create
	* @example 
	* <!-- Example carousel setup in HTML NOTE: This class does not handle the sizing and styles of the actual carousel, this is just an example set up -->
	* <div style="overflow: hidden;"class="carousel_container"> <!-- Outside the carousel, used to hide "offscreen" carousel elements -->
	* 	<ul class="carousel"> <!-- This is the element used for the carousel itself -->
	* 		<li class="template slide"> <!-- Refer to this element for the template -->
	*			<div class="title"></div>
	*		</li>
	*	</ul>
	* </div>
	*/
	function Carousel($target, options, $) {
		var defaults = {},
		// Used to validate increment/offset values
		regex_decimal_num = /[0-9]+(\.[0-9]+)*/,
		regex_measurement = /((px)|%){1}/,
		regex_valid = /^[0-9]+(\.[0-9]+){0,1}((px)|%)$/,
// 		regex_valid = /^[0-9]+(\.[0-9]+)*((px)|%)$/,
		// Misc values
		template_clone,
		i = 0,
		count = 0,
		_this = this;
		
		//if(typeof $target.data('carousel') !== 'undefined')
			//return false;
			
		// Carousel stuff
		this.$carousel = false;
		this.$carousel_elements = [];
		this.$template = false;
		this.data = [];
		this.current_index = 0; // current index of the 'first' slide
	
		// Flags
		this.debug = false;
		this.paused = false;
		this.in_progress = false;
		this.use_gsap = true;
	
		// Slide stuff
		this.$slides = false; // jQuery object representing all slides (not an array!). Used for animation.
		this.slides = []; // Changing "list" of slides, used to determine slide order
		this.original_slides = [];
		this.increment = 0;
		this.measurement = '%'; // should be in either % or px
		this.offset = 0; // Generally used for hard positioning
		this.duration = 0;
		this.minimum = 0;
	
		//stepTo helper variables
		this.step_tween = false;
		this.step_to_tween = false;
		
		// Slide options
		defaults = {
			debug: false,
			increment: 0,
			offset: 0,
			duration: 0,
			useGSAP: true,
			$template: false,
			data: [],
			minimum: 0,
			$slides: $(),
			ignoreTargets: '',
			activeClass: 'active'
		};
		
		options = $.extend(defaults, options);
		
		// Store variables
		this.options = options;

		if (!$target) {
			if (console_flag && this.debug) console.log('Console: Error: Missing parameters');
			return;
		}
	
		/*
		*
		* ST Note: Maybe there's a way to function out the "process" step
		* ARNG Note: Still need it for some numbers
		*/
	
		// Process options		
		// Map values
		this.debug = options.debug;
		this.duration = options.duration;
		this.use_gsap = options.useGSAP;
		this.minimum = options.minimum;
		this.data = options.data;
		this.$template = options.$template;
		this.ignoreTargets = options.ignoreTargets;
		this.activeClass = options.activeClass;
		
		// Process increment
		if (typeof options.increment !== 'undefined') {	
			if (regex_valid.test(options.increment)) {	
				this.increment = parseFloat(regex_decimal_num.exec(options.increment));
				this.measurement = regex_measurement.exec(options.increment)[0];
			} else if (console_flag && this.debug) console.log('Carousel: Not valid', options.increment);
		}
	
		// Process offset
		if (typeof options.offset !== 'undefined') {
			if (regex_valid.test(options.offset)) {	
				this.offset = parseFloat(regex_decimal_num.exec(options.offset));
				var offset_measurement = regex_measurement.exec(options.offset)[0];
			
				// Currently offset measurement unit must match the increment offset unit for it to be used
				if (offset_measurement !== this.measurement && typeof options.increment !== 'undefined') this.offset = 0;
				else this.measurement = offset_measurement;
			} else if (console_flag && this.debug) console.log('Carousel: Not valid', options.offset);
		}
	
		this.$carousel = $target;
		
		// Create slides from template and provided data else assume all children inside carousel are slides if there isn't a template
		if (this.$template && this.data.length !== 0) {
			// Create slides for each data part

			for(i = 0; i < this.data.length; i++) {
				template_clone = this.$template.clone();
				template_clone.removeClass('template');
				this.$carousel.append(template_clone);
				template_clone.css('left', (this.increment*i)+this.offset+this.measurement);
				template_clone.data('product', this.data[i]);
				template_clone.attr('id', 'slide_'+i);
				this.slides.push(template_clone);
			}
			this.$slides = this.$carousel.children().not(this.$template);
		
		// Create slides from existing children (while ignoring ignoreTargets defined in the options)
		} else if (!this.$template) {
						
			this.slides = [];
			this.$slides = options.$slides.length !== 0 ? options.$slides.not(options.ignoreTargets) : this.$carousel.children().not(options.ignoreTargets);

			// Mark slide with active class to keep place
			this.$slides.first().addClass(this.activeClass);
			this.$slides.each(function() {
				_this.slides.push($(this));
				$(this).css('left', (_this.increment * count++) + _this.offset + _this.measurement); // Position each slide
			});
		}
		this.original_slides = this.slides.slice(0);
		
		if(options.debug) console.log('carousel created');
		
		return this;
	}

	Carousel.prototype = {
		/**
		* step
		*
		* progresses carousel a step. Defaults to instantly moving elements within the carousel. If GSAP (TweenMax, etc) is installed
		* slides are animated. Slides will not progress if animation is in progress, or if the carousel is paused.
		* @param {boolean} dir - true if the slides should progress forward, or backwards. Defaults to true.
		*/	
		step : function(dir, callback){
			// Default to true, forwards motion
			if (dir === undefined) dir = true;
				
			// Do not need to step if there's only one slide, or if set less slides than the minimum
			if (this.slides.length === 1 || this.slides.length <= this.minimum) {
				if (this.debug) console.log(this.$carousel, 'Step: Carousel: Only one slide: No step');
				return;
			}
		
			// Do not allow progression if paused
			if (this.paused) {
				if (this.debug) console.log('Step: Carousel: Paused');
				if(typeof callback !== 'undefined' && typeof callback === 'function')
						callback();
				return;
			}
			
			// Do not allow progress if slide animations are in progress
			// Is there a way to avert this? Queue animations or something?
			if (this.in_progress) {
				if (this.debug) console.log('Step: Carousel: In progress');
				return;
			}
		
			// Set up variables for use
			var increment = this.increment,
				slides = this.slides,
				_this = this;
		
			this.in_progress = true;
		
			if (dir) {
				if (this.debug) console.log('Step: Carousel: Forwards');
			
				this.slides[0].trigger('slideWillLoseActive');
				this.slides[0].addClass('losingActive');
				
				// Push the first element into the rear
				var shifted = this.slides.shift();
				this.slides.push(shifted);
				this.current_index = this.current_index+1 >= this.slides.length ? 0 : this.current_index+1;
			
				this.slides[0].trigger('slideWillGainActive');
			
				// If we can use GSAP then do so, else fallback to non animated carousel
				if (this.use_gsap && (TweenMax || TweenLite)) {
					// Clone the first element as a visual dummy to ensure a cohesive slide animation flow
					var shifted_clone = shifted.clone().css('left',(slides.length)*this.increment+this.offset+this.measurement).addClass('clone');
					this.$carousel.append(shifted_clone);
				
					/* Clone tween */
					TweenMax.to(shifted_clone, this.duration, {'left' : '-=' + (this.increment + this.measurement), onComplete:function() {
						_this.$carousel.find('.clone').remove(); //shifted_clone.remove();
						_this.in_progress = false;
					}});
				
					/* Main tween */
					this.step_tween = TweenMax.to(this.$slides, this.duration, {'left' : '-=' + (this.increment + this.measurement), onComplete:function() {
						shifted.css('left', ((slides.length-1)*_this.increment)+_this.offset+_this.measurement);
						_this.in_progress = false;
						_this.step_tween = false;
						
						_this.$carousel.trigger('carousel_updated', [_this.current_index]);
						
						if(typeof callback !== 'undefined' && typeof callback === 'function')
							callback();
					}});
				} else {
					// Move slides forward without animation
					for(var f = 0; f < this.slides.length; f++) {
						$(this.slides[f]).css('left', (this.increment * f) + this.offset + this.measurement);
					}
					this.in_progress = false;
				}
			} else {
				if (this.debug) console.log('Step: Carousel: Back');
			
				this.slides[0].trigger('slideWillLoseActive');
				this.slides[0].addClass('losingActive');
				
				// Push the last element into the front
				var popped = this.slides.pop();
				this.slides.unshift(popped);
				this.current_index = this.current_index-1 < 0 ? this.slides.length-1 : this.current_index-1;
			
				this.slides[0].trigger('slideWillGainActive');
			
				if (this.use_gsap && (TweenMax || TweenLite)) {
					// Clone the last element as a visual dummy to ensure a cohesive slide animation flow
					var popped_clone = popped.clone().css('left', -increment + this.offset + _this.measurement).addClass('clone');
					this.$carousel.prepend(popped_clone);
				
					/* Clone tween */
					TweenMax.to(popped_clone, this.duration, {'left' : '+=' + (this.increment + this.measurement), onComplete:function() {
						_this.in_progress = false;
					}});
				
					/* Main tween */
					this.step_tween = TweenMax.to(this.$slides, this.duration, {'left':'+='+(this.increment+this.measurement), onComplete:function() {
						popped.css('left', _this.offset+_this.measurement);
						_this.$carousel.find('.clone').remove(); //popped_clone.remove();
						_this.in_progress = false;
						_this.step_tween = false;
						
						_this.$carousel.trigger('carousel_updated', [_this.current_index]);
						
						if(typeof callback !== 'undefined' && typeof callback === 'function')
							callback();
					}});
				} else {
					// Move slides backward without animation
					for(var b = 0; b < this.slides.length; b++) {
						$(this.slides[b]).css('left', (this.increment * b) + this.offset + this.measurement);
					}
					this.in_progress = false;
				}
			}

			if(!this.use_grap && typeof callback !== 'undefined' && typeof callback === 'function')
				callback();

			// Trigger willBecomeActive for slide to become active, and trigger willLoseActive for slide to lose Active
			this.slides[0].addClass('active').trigger('slideHasGainedActive').siblings().each(function(){
				var $this = $(this);
			
				if($this.hasClass('active'))
					$this.trigger('slideHasLostActive');
			
				$this.removeClass('active').removeClass('losingActive');
			});
		
		
			//this.$carousel.trigger('carousel_updated', [this.current_index]);
		},
		/**
		* stepTo
		* 
		* Moves to the specified slide index
		* @param {int} index - index of slide to move to
		*/
		stepTo: function(index)
		{
			var dir = 0,
			_this = this,
			i = 0;
		
			if(index >= this.slides.length || this.current_index === index)
				return;
		
			dir = index-this.current_index === 0 ? 0 : (index-this.current_index > 0 ? 1 : -1);
		
			this.slides = this.original_slides.slice(0);
			//this.slides = this.slides.concat(this.slides.splice(0, index));
			// Animated rearrangement
			if(this.use_gsap && (TweenMax || TweenLite) && this.duration !== 0){
				// Kill all existing carousel related tweens 
				if(this.step_to_tween){
					this.step_to_tween.eventCallback('onComplete', (function(){}));
					this.step_to_tween.progress(1);
					this.step_to_tween = false;
					this.$carousel.find('.clone').remove();
				}
			
				if(this.step_tween)
				{
					this.step_tween.eventCallback('onComplete', (function(){}));
					this.step_tween.progress(1);
					this.step_tween = false;
				}
				// Trigger willBecomeActive for slide to become active, and trigger willLoseActive for slide to lose Active
				this.slides[0].addClass('active').trigger('slideHasGainedActive').siblings().each(function(){
					var $this = $(this);
			
					if($this.hasClass('active'))
						$this.trigger('slideHasLostActive');
			
					$this.removeClass('active');
				});
			
				/* Clone slides so that visually there is something to show after the "last" slide */
				var clone_slides = [],
				$clone_slides = $();
				if(dir) // Only an issue when going forwards
				{
					clone_slides = [];
					$clone_slides = $();
					for(i = 0; i < this.original_slides.length; i++)
					{
						var clone = this.original_slides[i].clone().addClass('clone');
						clone_slides.push(clone);
						this.$carousel.append(clone);
						$clone_slides = $clone_slides.add(clone);
					}
				}
				var carousel_slides = this.slides.concat(clone_slides);
			
				/* Layout the strip */
				for(i = -this.current_index; i <= carousel_slides.length-this.current_index; i++) {
					$(carousel_slides[i+this.current_index]).css('left', (this.increment * i) + this.offset + this.measurement);
				}

				this.in_progress = true;
			
				this.step_to_tween = TweenMax.to(this.$slides.add($clone_slides), this.duration, {'left' : '-=' + (dir*this.increment*Math.abs(index-this.current_index) + this.measurement), onComplete:function() {
					_this.step_to_tween = false;
					_this.in_progress = false;
					_this.$carousel.find('.clone').remove();
				
					// Rearrange slides for normal increments
					_this.slides = _this.slides.concat(_this.slides.splice(0, index));
					for(var i = 0; i < _this.slides.length; i++) {
						$(_this.slides[i]).css('left', (_this.increment * i) + _this.offset + _this.measurement);
					}
					
					_this.slides[0].addClass('active').siblings().removeClass('active');
					
					_this.current_index = index;
					_this.$carousel.trigger('carousel_updated', [_this.current_index]);
				}});
			}
			// Non animated element rearrangement
			else {
				// Rearrange slides
				this.slides = this.original_slides.slice(0);
				this.slides = this.slides.concat(this.slides.splice(0, index));
				for(i = 0; i < this.slides.length; i++) {
					$(this.slides[i]).css('left', (this.increment * i) + this.offset + this.measurement);
				}
			
				// Trigger willBecomeActive for slide to become active, and trigger willLoseActive for slide to lose Active
				this.slides[0].addClass('active').trigger('slideHasGainedActive').siblings().each(function(){
					var $this = $(this);
			
					if($this.hasClass('active'))
						$this.trigger('slideHasLostActive');
			
					$this.removeClass('active');
				});
			
				this.current_index = index;
				this.$carousel.trigger('carousel_updated', [_this.current_index]);
			}
		
			//this.in_progress = false;
		},
		/**
		* setPaused
		*
		* sets the carousel to paused based on flag
		* @param {boolean} flag - true for paused, false for not paused
		*/	
		setPaused : function(flag) { this.paused = flag; }, 
		/**
		* update
		*
		* @description Updates the carousel based on new or no-longer-in-the-ignore-list children found in its DOM. Otherwise hides existing slides that have fallen
		* On the ignore list. Repositions all elements when 'done'.
		*/
		update: function() {
			var $slides = this.$slides,
			slides = this.slides,
			$carousel = this.$carousel,
			$newSlides = $carousel.children().not(this.$slides).not(this.ignoreTargets), // Look for children that aren't on the ignore list nor already a processed slide
			i = 0,
			ignoreTargets = this.ignoreTargets,
			debug = this.debug,
			_this = this;
			
			// Do not allow update if slide animations are in progress
			/*
			console.log(this.in_progress);
			
			if (this.in_progress) {
				if (this.debug) console.log('Step: Carousel: In progress: Waiting for animation to end');
				this.$carousel.one('carousel_updated', function() {
					console.log('asdf');
					_this.update();
				});
				return;
			}*/
			
			if(this.in_progress) {
				this.step_tween.pause().progress(0);
				this.$carousel.find('.clone').remove();
				this.in_progress = false;
			}
			// Remove any slide that comes into the ignore list
			$slides.each(function(){
				var $this = $(this),
				i = 0;
				
				
				if($this.is(ignoreTargets)) {
					for(i = 0; i < slides.length; i++)
					{
						if(slides[i].is($this))
						{
							if(debug) console.log('update: removed', $this);
							slides.splice(i, 1);
							return;
						}
					}
				}
			});
			
			// Append/prepend slides based on DOM neighbors
			$newSlides.each(function() {
				var $this = $(this),
				$prev = $this.prev(),
				$next = $this.next(),
				append = true,
				$target = $(),
				i = 0;
				
				if($prev.length !== 0)
					$target = $prev;
				else if ($next.length !== 0) {
					$target = $next;
					append = false;
				}
				// No slides? Just push in the new one
				else {
					if(debug) console.log('update: added', $this);
					slides.push($this);
					return;
				}
				
				// Insert slide into slides list
				if($target.length !== 0) {
					for(i = 0; i < slides.length; i++)
					{
						if(slides[i].is($target)) {
							if(debug) console.log('update: added', $this, (append ? 'after' : 'before'), $target);
							slides.splice(i+(append ? 1 : -1), 0, $this);
							return;
						}
					}
				}
				
			});
			
			// (Re)Position slides
			for(i = 0; i < slides.length; i++)
			{
				$(slides[i]).css('left', (this.increment * i) + this.offset + this.measurement);
			}
	
			// Mark first slide in the slides array as active
			$(slides[0]).addClass(this.activeClass).siblings().removeClass(this.activeClass);
	
			// Update jQuery selector with new slides
			this.$slides = $carousel.children().not(this.ignoreTargets);
			this.original_slides = [];
			this.$slides.each(function(){
				_this.original_slides.push($(this));
			});
		},
		/**
		* @function getSlides
		* @returns {jQuery} All slides in this carousel as a jQuery object
		*/
		getSlides: function() {
			return this.$slides;
		}
	};



	// Should refer to all carousels created using this plugin
	var carousel_list = [],
		carousel_paused = false,
		debug = false,
		//Carousel dots
		$dot_container = false, // Target element to use for dot holder
		$dot_template = false; // Template to use for dot
		//Carousel dots
	
	/**
	* el_carousel
	*
	* creates a carousel out of a selected element using the Carousel object. Carousel object is stored in the 'carousel' data attribute. Carousels
	* are also stored in the carousel_list array for reference (assuming that there might be more than one carousel in a project).
	* 
	* @alias el_carousel
	* @function external:"jQuery.fn".el_carousel
	* @param {object} options - An array of objects to set different options for the carousel object
	*	@param {boolean} [options.debug=false] - sets the carousel to log to console
	*	@param {string} [options.increment=0] - sets the increment to position slides ex: 9px, 9%, 9.9px, 9.9%.
	*	@param {string} [options.offset=0] - sets the from the left edge of the carousel ex. 9px, 9% 9.9px, 9.9%. Must match units used in increment, i.e. px with px; if increment is set in the options.
	*	@param {float} [options.duration=0] - sets the animation speed if GSAP
	*	@param {boolean} [options.useGSAP=true] - Wether to use GSAP for animations or not.
	*	@param {object} [options.data=[]] - An array of objects representing data... [TEMP]
	* 	@param {int} [options.minimum=0] - Minimum amount of slides for animation to happen
	*	@param {jQuery} [options.$dot_container] - Element to contain dot nav elements
	* 	@param {jquery} [options.$dot_template] - Element that's a template for dot nav elements added to the $dot_container
	* 	@param {jQuery} [options.$slides] - Slides to use for carousel
	* 	@param {string} [options.ignoreTargets] - Elements to ignore, they will not be processed or positioned. Recommended to hide these elements with display: none
	* 	@param {string} [options.activeClass='active'] - Active class to mark elements with, defaults to 'active', has no bearing on carousel functionality, but marks the 'current' slide
	* @returns {object} - The selected element used for the carousel. Nothing if a carousel hasn't been successfully created.
	* 
	* @example 
	* <!-- Example carousel setup in HTML NOTE: This class does not handle the sizing and styles of the actual carousel, this is just an example set up -->
	* <div style="overflow: hidden;"class="carousel_container"> <!-- Outside the carousel, used to hide "offscreen" carousel elements -->
	*	<ul class="carousel"> <!-- This is the element used for the carousel itself -->
	*		<li class="template slide"> <!-- Refer to this element for the template -->
	*			<div class="title"></div>
	*		</li>
	*	</ul>
	* </div>
	*/	
	$.fn.el_carousel = function(options){
		if (options) debug = options.debug !== undefined ? options.debug : debug;
		
		var $targets = $(this);
		
		$targets.each(function() {
			var $this = $(this),
			carousel = new Carousel($this, options, $);

			if (carousel) {
				
				
				// Add to carousel_list for later reference
				$this.data('carousel', carousel);
				carousel_list.push(carousel);
				if (console_flag && debug) console.log('Carousel: Created');
				// Event options

				if (typeof options !== 'undefined' && options) {
					// Must have both a dot container and a dot template to work
					if(options.$dot_container !== undefined && typeof options.$dot_template !== 'undefined')
					{
						$dot_container = options.$dot_container;
						$dot_template = options.$dot_template;
						
						// Remove all dot navs that aren't template
						$dot_container.children().not('.template').remove();
						
						var $dots = $();
						if(options.$template === false || typeof options.$template === 'undefined')
						{
							for(var i = 0; i < $this.children().length; i++)
							{
								var $dot_clone = $dot_template.clone().removeClass('template');
								$dot_container.append($dot_clone);
								$dots = $dots.add($dot_clone);
								if(i === 0)
									$dot_clone.addClass('active');
							}
						}

						$dot_container.off('click').on('click', function(e) {
							e.preventDefault();
							var $target = $(e.target);
							if(carousel_paused) return;
						
							$target.addClass('active').siblings().removeClass('active');
							carousel.stepTo($target.index()-1);
						
						});
					
						$(window).off('carousel_updated').on('carousel_updated', function(e, index){
							$dots.eq(index).addClass('active').siblings().removeClass('active');
						});
					}
					else
					{
						if (console_flag && debug) console.log('Carousel: Failed to create dots with:', options.$dot_container, options.$dot_template);
					}
			
					// Click event handling
					if (typeof options.click_next !== 'undefined') {				
						$(options.click_next).off('click').on('click', function(e) {
							e.preventDefault();
							if (carousel_paused) return;
							carousel.step();
						});
					}
				
					if (typeof options.click_prev !== 'undefined') {		
						$(options.click_prev).off('click').on('click', function(e){
							e.preventDefault();
							if (carousel_paused) return;
							carousel.step(false);
						});
					}
					
				}
			} else {
				if (console_flag && debug) console.log('Carousel: Failed');
				return;
			}
		});
		
		return $targets;
	};
	
	/**
	* setDisableCarouselControls
	*
	* sets a global pause for all carousels to prevent events from progressing them
	* 
	* @alias setDisableCarouselControls
	* @function external:"jQuery.fn".setDisableCarouselControls
	* @param {boolean} flag - true to pause, false otherwise
	*/
	$.fn.setDisableCarouselControls = function(flag){
		if (flag === undefined) return;
		carousel_paused = flag;
		return $(this);
	};
	
	/**
	* carouselSetEnabled
	*
	* @alias carouselSetEnabled
	* @function external:"jQuery.fn".carouselSetEnabled
	* @param {boolean} flag - True to enable carousel, false to disable it. Must be set.
	* @returns {jQuery} - jQuery selector  this function was called on
	* 
	*/
	$.fn.carouselSetEnabled = function(flag){
		var $this = $(this);
		
		$this.each(function() {
			var $this = $(this),
			carousel = $this.data('carousel');
		
			if(typeof $this.data('carousel') === 'undefined' || typeof flag === 'undefined')
				return;
			
			if(debug) console.log('enableDisableCarousel', flag, $this.attr('class'), $this.attr('id'));
			carousel.paused = !flag;
		});
		
		return $this;	
	};
	
	// Previous function name
	$.fn.enableDisableCarousel = $.fn.carouselSetEnabled;
	
	/**
	* carouselNext
	*
	* Progresses the carousel to the next slide
	*
	* @alias carouselNext
	* @function external:"jQuery.fn".carouselNext
	*/
	$.fn.carouselNext = function(callback){
		var $this = $(this);
		
		$this.each(function() {
			var $this = $(this);
			
			if(typeof $this.data('carousel') === 'undefined')
				return;
		
			$this.data('carousel').step(true, callback);
		});
		
		return $this;
	};
	
	/**
	* carouselPrev
	*
	* Progresses the carousel to the previous slide
	*
	* @alias carouselPrev
	* @function external:"jQuery.fn".carouselPrev
	*/
	$.fn.carouselPrev = function(callback){
		var $this = $(this);
		
		$this.each(function() {
			var $this = $(this);
			if(typeof $this.data('carousel') === 'undefined')
				return;
			
			$this.data('carousel').step(false, callback);
		});
		return $this;
	};
	
	/**
	* carouselTo
	*
	* Moves carousel to a specified index
	*
	* @alias carouselTo
	* @function external:"jQuery.fn".carouselTo
	* @param {index} index - Index to move to
	* @returns {jQuery} - jQuery selector  this function was called on
	*/
	$.fn.carouselTo = function(index){
		var $this = $(this);
		
		$this.each(function() {
			var $this = $(this);
			
			if(typeof $this.data('carousel') === 'undefined')
				return;
			
			$this.data('carousel').stepTo(index);
		});
		return $this;
	};
	
	/**
	* carouselDestroy
	*
	* @function external:"jQuery.fn".carouselDestroy
	* @description Destroys carousel associated with the target (will need to be recreated for functionality to return)
	* @returns {jQuery} - jQuery selector  this function was called on
	*/
	$.fn.carouselDestroy = function(){
		var $this = $(this);
		
		$this.each(function(){
			var $this = $(this);
			
			$this.removeData('carousel');
		});
		return $this;
	};
	
	/**
	* carouselUpdate
	* 
	* @function external:"jQuery.fn".carouselUpdate
	* @description: Updates the carousel based on changes to its DOM
	* @returns {jQuery} - jQuery selector  this function was called on
	*/
	$.fn.carouselUpdate = function() {
		var $this = $(this);
		
		$this.each(function(){
			var $this = $(this);
			
			if(typeof $this.data('carousel') === 'undefined')
				return;
			
			$this.data('carousel').update();
		});
		
		return $this;
	};
	
	/**
	* carouselGetSlides
	*
	* @function external:"jQuery.fn".carouselGetSlides
	* @returns {jQuery} - All slides found in all selectors (if they are carousels)
	*/
	$.fn.carouselGetSlides = function() {
		var $this = $(this),
		$slides = $();
		
		$this.each(function(){
			var $this = $(this);
			
			if(typeof $this.data('carousel') === 'undefined')
				return;
			
			$slides = $slides.add($this.data('carousel').getSlides());
		});
		
		return $slides;
	};
	
})(jQuery);
	